
import {
    GENERATE_EXIT_NAVIGATOR_SUCCESS,
    UPDATE_EXIT_NAVIGATOR_SUCCESS,
  } from '../actions/types';
  
  const INITIAL_STATE = {
    exitNavigator: null
  };
  
  export default function exitNavigatorReducer (state=INITIAL_STATE, action) {
    switch (action.type) {
      case GENERATE_EXIT_NAVIGATOR_SUCCESS:
        return { ...state, exitNavigator: action.payload.exit_navigator };
      case UPDATE_EXIT_NAVIGATOR_SUCCESS:
        return { ...state, exitNavigator: action.payload.exit_navigator };
      default:
        return state;
    }
  };